import { useMemo, useEffect } from 'react'

type ErrorData = {
	errorFieldKey: string
	error: string
}

type UseFormValidationParams = {
	fieldKey: string
	data?: ErrorData | null
	setValue: (fieldKey: string, value: any) => void
	currentQuestionId: string | undefined
	trigger: () => Promise<boolean>
	getValues: (fieldKey: string) => any
	isValid: boolean
}

export const useFormValidation = ({
	fieldKey,
	data,
	setValue,
	currentQuestionId,
	trigger,
	getValues,
	isValid,
}: UseFormValidationParams): void => {
	const memoizedError = useMemo(
		() => data?.error,
		[data],
	) as unknown as ErrorData

	useEffect(() => {
		if (!isValid) {
			trigger()
		}
	}, [getValues, isValid, trigger, fieldKey])

	useEffect(() => {
		if (
			memoizedError &&
			`${memoizedError.errorFieldKey}-${currentQuestionId}` === fieldKey
		) {
			setValue(fieldKey, '')
		}
	}, [memoizedError, setValue, fieldKey, currentQuestionId])
}
